import dateFormat from "dateformat";
import dateWithoutTimezone from "./dateUtils";

export function date(value, mask = undefined, timezone = true) {
    const v = isNaN(value) ? value : Number(value);
    const toDate = new Date(v);
    let dateValue = null;
    if (timezone) {
        dateValue = toDate.getTime() ? toDate : v;
    } else {   
        dateValue = toDate.getTime() ? dateWithoutTimezone(toDate) : v;
    }
    const maskToUse = mask ? mask : "dd/mm/yyyy";
    return dateValue instanceof Date ? dateFormat(dateValue, maskToUse) : null;
}

export const mapSelectedCalendarType = (cal) => {
    return cal && cal.name
        ? cal.name.replaceAll(/\s/g, "").trim().toLocaleLowerCase()
        : cal && typeof cal !== "object"
          ? cal.replaceAll(/\s/g, "").trim().toLocaleLowerCase()
          : "fiscalyear";
};
